import Header from '../Header/Header';
import React, { useState, useEffect, useCallback } from 'react'
import './index.css'
import { useNavigate, useLocation } from 'react-router-dom';
import { Select, ConfirmationPopup, ICONS, SignaturePad } from '@ohif/ui';
import { Formik, Form, ErrorMessage } from 'formik';
import { hospitalFormSchema } from "./schema"
import { SuccessModal, Loader } from '@ohif/ui';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { useDispatch, useSelector } from 'react-redux';
import changePasswordApi from '../rtk-apis/user/changePassword';
import hospitalDetailApi from '../rtk-apis/hospital/hospitalDetails';
import { AppDispatch, RootState } from '../store/store';
import { _commonUrls, _hospitalUrls } from '@custom/Utils/constants/apiUrls';
import { calculateDaysLeft, capitalizeWords, convertKBtoGB, customStyle, formatDate, getCurrencyContact, getLocalPhoneNumber } from '@custom/Utils/utils';
import updateProfileImage from '@custom/rtk-apis/report/updateProfileImage';
import { SignatureDropzone } from '@custom/Profile';
import { HospitalDetails } from '@custom/Utils/constants/interfaces';
import { useTheme } from "../../ui/src/contextProviders"
import TeleRadiologyPrices from './teleRadiologyPrices';
import odooApprovedApi from '@custom/rtk-apis/hospital/odooApproved';
import { _purchase_type, _roleType } from '@custom/Utils/constants/appConstants';
import { clearHospitalDetails } from '@custom/store/slices/hospital/hospitalDetails';
import ServiceCheckbox from './Services/servicesCheckbox';
import serviceConfig from './Services/servicesConfig';
import getBillingGeneralSettings from '@custom/rtk-apis/billing/getGeneralSettings';
import PricingCard from './PricingCard';
import { servicesManager } from '../../app/src/App';
import AddOnSelectionPopup from './AddOnSelectionPopup';
import ExtraStoragePopup from './ExtraStoragePopup';
import CreditTopUpModal from './CreditTopUpmodal/index';
import createStripePortalSession from '@custom/rtk-apis/payement-gateway/createStripeSession';
import AddOnsForm from '@custom/Settings/Pricing/AddOnsForm';
import { getAddons } from '@custom/rtk-apis/Setting/addons/getAddons';
import BuyExtraStorageModal from './BuyExtraStorageModal';
import { getExtraStorage } from '@custom/rtk-apis/Setting/extraStorage/getExtraStorage';
import deductCreditForStorage from '@custom/rtk-apis/paymentViaCredit/deductCreditforStorage';
import ExtraStoragePlanDetailPopup from './ExtraStoragePlanDetail';
import CreditsForCaseToCase from '@custom/Settings/Pricing/CreditsForCaseToCase';
import CaseToCaseCreditForHospital from '@custom/Settings/Pricing/Case2CaseCreditsForHospital';

const SpecialtiesValueContainer = ({ children, getValue, hasValue, selectProps }: any) => {
  const values = getValue();
  const isSearching = selectProps?.inputValue?.length > 0;
  const input = React.Children.toArray(children).filter(
    (child: any) => child?.props?.isHidden !== undefined
  );
  return (
    <div
      className="customSelect__value-container"
      style={{ display: 'flex', alignItems: 'center', flex: 1, overflow: 'hidden', padding: '2px 8px' }}
    >
      {hasValue && values.length > 0 && !isSearching && (
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#000', fontSize: '14px' }}>
          {values.map((v: any) => v.label).join(', ')}
        </span>
      )}
      {input}
    </div>
  );
};

const defaultHospitalDetails: HospitalDetails = {
  _id: '',
  hospitalName: '',
  hospitalEmailId: '',
  address: '',
  zipCode: '',
  country: '',
  state: '',
  city: '',
  hfrId: '',
  website: '',
  contactNumberCountryCode: '',
  hospitalData: '',
  contactNumber: '',
  whatsappCountryCode: '',
  whatsapp: '',
  emergencyContactNumberCountryCode: '',
  emergencyContactNumber: '',
  noOfHealthCareProfessional: '',
  specialitites: '',
  sameAsContact: '',
  signature: '',
  telepathology: false,
  teleradiology: false,
  aiServices:false,
  government: false,
  speechToText:false,
  teleCreditServices: [],
  teleCreditServicesForCase2Case: [],
  user: {
    _id: '',
    name: '',
    email: '',
    contactNumber: '',
    countryCode: '',
    whatsapp: '',
    whatsappCountryCode: '',
    sameAsContact: '',
    superAdminSameAsContact: '',
  },

};

const AddEditHospital = () => {
   const { uiNotificationService } = servicesManager.services;
  const navigate = useNavigate();
  const location = useLocation()
  const [countryCode, setCountryCode] = useState(['+91']);
  const [countryList, setCountryList] = useState([])
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [specialitites, setSpecialitities] = useState([]);
  const [edit, setIsEdit] = useState(false)
  const [modal, setModal] = useState(false);
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(false);
  const [isExtraStoragePopupOpen,setIsExtraStoragePopupOpen] = useState(false);
  const [isBuyExtraStoragePlanModalOpen, setIsBuyExtraStoragePlanModalOpen] = useState(false);
  const [extraStoragePlan, setExtraStoragePlan] = useState<any>(null);
  const [password, setPassword] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  })
  const [errorMessage, setErrorMessage] = useState('');
  const [hospitalDetails, setHospitalDetails] = useState<HospitalDetails>(defaultHospitalDetails)
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationText, setConfirmationText] = useState("");
  const [isHospitalSuperAdminEditing, setIsHospitalSuperAdminEditing] = useState(location?.state?.isHospitalSuperAdminEditing ?? false);
  const [folderName, setFolderName] = useState<string>('');
  const [isOpenSignaturePad, setOpenSignaturePad] = useState(false);
  const [profileImage, setProfileImage] = useState<string>('');
  const [signatureImage, setSignatureImage] = useState<string>('');
  const [isApprovePopupOpen, setIsApprovePopupOpen] = useState(false);
  const [hospitalToApprove, setHospitalToApprove] = useState(null);
  const [selectedCountryCode, setSelectedCountryCode] = useState<string>('+91');
  const [purchasedAddonsNames, setPurchasedAddonsNames] = useState<String[]>([]);
  const [isBuyExtraStorageModalOpen, setIsBuyExtraStorageModalOpen] = useState(false);
  const [isExtraStoragePlanDetailPopupOpen, setIsExtraStoragePlanDetailPopupOpen] = useState(false);
  const [hover, setHover] = useState(false);

  const { hospitalData } = location?.state || {}
  const showModal = location?.state?.showModal || false;
  const locationCreditData = hospitalData?.teleCreditServices || [];
  const locationCase2CaseData = hospitalData?.teleCreditServicesForCase2Case || [];
  const dispatch = useDispatch<AppDispatch>();
  const passwordData = useSelector((state: RootState) => state?.changePasswordResponse);
  const imageResponse = useSelector((state: RootState) => state.updateProfileImageResponse);
  const hospitalDetailsData = useSelector((state: RootState) => state?.hospitalDetailsResponse);
  const odooApprovedData = useSelector((state: RootState) => state?.odooApprovedResponse);
  const billingGeneralSettingsData = useSelector((state: RootState) => state.getBillingGeneralSettingsSliceResponse);
  const getAddonsResponse = useSelector((state: RootState) => state.getAddonsResponse);
  const [pauseConfirmationModal, setPauseConfirmationModal] = useState({
    isOpen: false,
    message: '',
    onSubmit: () => { }
  })
  const getCaseCreditResponse = useSelector((state: RootState) => state?.getCaseCreditResponse);
  const defaultCountryCode = billingGeneralSettingsData?.status && billingGeneralSettingsData?.result?.currency ? getCurrencyContact(billingGeneralSettingsData.result.currency) : '+91';

  const [formInitialValue, setFormInitialValue] = useState({
    from: '',
    isApproved: false,
    product: [],
    hospitalName: '',
    hospitalEmailId: '',
    address: '',
    zipCode: '',
    country: '',
    state: '',
    city: '',
    hfrId: '',
    website: '',
    contactNumberCountryCode: '+91',
    contactNumber: '',
    whatsappCountryCode: '+91',
    whatsappNumber: '',
    emergencyContactNumberCountryCode: '+91',
    emergencyContactNumber: '',
    numberOfHealthcareProfessionals: '',
    specialitites: [],
    signature: '',
    superAdminName: '',
    superAdminEmail: '',
    superAdminContactNumber: '',
    superAdminContactNumberCountryCode: '+91',
    superAdminWhatsappNumber: '',
    superAdminWhatsappNumberCountryCode: '+91',
    sameAsContact: false,
    superAdminSameAsContact: false,
    telepathology: false,
    teleradiology: false,
    speechToText:false,
    aiServices:false,
    government: false,
    teleCreditServices: [],
    teleCreditServicesForCase2Case: [],
    CASE_TO_CASE_PLAN: false
  });
  const [creditData, setcreditData] = useState<any[]>(locationCreditData);
  const [case2caseData, setCase2caseData] = useState<any[]>(locationCase2CaseData);
  const [updatedTableData, setUpdatedTableData] = useState<any[]>([]);
  const [updatedCase2CaseTableData, setUpdatedCase2CaseTableData] = useState<any[]>([]);
  const [isAddOnPopupOpen, setIsAddOnPopupOpen] = useState(false);
  const [selectedAddOns, setSelectedAddOns] = useState<string[]>([]);
  const [isHospitalData, setIsHospitalData] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formAddons, setFormAddons] = useState([]);

  const onExtraStoragePlanSelect = (plan: any) => {
    setExtraStoragePlan(plan);
    setIsBuyExtraStoragePlanModalOpen(false)
    setIsBuyExtraStorageModalOpen(true)
  }

  const handleCreditSubmit = (credits) => {
    const hospital_code = localStorage.getItem('hospitalCode') || sessionStorage.getItem('hospitalCode');
        const payload = {
        "product_name": 'Topup - Credit',
        // @ts-ignore
        "product_amount": credits,
        "purchase_type": _purchase_type.CREDIT,
        "hospital_code": hospital_code,
        "credits": credits
        }

        setLoading(true);

        dispatch(createStripePortalSession(payload)).catch((error) => {
          console.error('Error creating Stripe portal session:', error);
          setLoading(false);
        });
  };

  const onDrop = useCallback((acceptedFiles, setFieldValue) => {
    const file = acceptedFiles[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFieldValue('signature', reader.result);
        uploadSignatureFile(file, setFieldValue );
      };
      reader.readAsDataURL(file);
    }
  }, []);

  const uploadSignatureFile = (file, setFieldValue) => {
    if (file) {
      setFolderName("signature");
      const formData = new FormData();
      formData.append('file', file);
      formData.append('folderName', "signature");

      dispatch(updateProfileImage(formData))
        .unwrap()
        .then((result) => {
          const signatureUrl = result?.result || '';
          setFieldValue('signature', signatureUrl);
          setSignatureImage(signatureUrl);
        })
        .catch((error) => {
          console.error('Error uploading file:', error);
        });
    }
  };

  const handleApproveHospital = () => {
    setHospitalToApprove({ _id: hospitalData._id, name: hospitalData?.hospitalName });
    setIsApprovePopupOpen(true);
  };

  const handleApproveConfirm = () => {
    setLoading(true);
    if (hospitalToApprove) {
      const hospitalId = hospitalToApprove._id;
      const obj = {
        _id: hospitalId
      }
      dispatch(odooApprovedApi(obj))
        .then((res) => {
          if (res?.payload?.success) {
            setModal(true);
            setTitle(res?.payload?.message);
            setLoading(false);
            setTimeout(() => {
              navigate(-1);
            }, 1000);
          }
        })
        .catch((err) => {
          console.error("Error approving hospital:", err);
          setLoading(false);
        });
    }
    setIsApprovePopupOpen(false);
    setHospitalToApprove(null);
  };

  const handleApproveCancel = () => {
    setIsApprovePopupOpen(false);
    setHospitalToApprove(null);
  };

  useEffect(() => {
    dispatch(getAddons());
  }, [dispatch]);

  useEffect(() => {
    if (hospitalData && Object.keys(hospitalData).length > 0) {
      if (hospitalData?.country) {
        fetchStates(hospitalData?.country, '', 'state')
      }
      if (hospitalData?.country && hospitalData?.state) {
        fetchStates(hospitalData?.country, hospitalData?.state, 'city')
      }
      setIsEdit(true);
    }
  }, [hospitalData])

  useEffect(() => {
    if (hospitalData && Object.keys(hospitalData).length > 0 && hospitalData?.teleCreditServices) {
      setcreditData(() => hospitalData?.teleCreditServices.map((item) => ({ credit: item.credit, _id: item._id, modality: item.modality, studyRegion: item.studyRegion })));
      setIsEdit(true);
    }
  }, [hospitalData?.teleCreditServices])

  useEffect(() => {
    if (hospitalData && Object.keys(hospitalData).length > 0 && hospitalData?.teleCreditServicesForCase2Case) {
      setCase2caseData(() => hospitalData?.teleCreditServicesForCase2Case.map((item) => ({ credit: item.credit, _id: item._id, modality: item.modality })));
      setIsEdit(true);
    }
  }, [hospitalData?.teleCreditServicesForCase2Case])

  const role = sessionStorage.getItem('role') || localStorage.getItem('role');
  useEffect(() => {
    if (hospitalDetailsData?.status === 'SUCCESS' && edit) {
      const details: any = hospitalDetailsData?.result;
      setHospitalDetails(details);
      updateFormInitialValue(details);
      if (details?.country) {
        fetchStates(details?.country, '', 'state');
      }
      if (details?.country && details?.state) {
        fetchStates(details?.country, details?.state, 'city');
      }
      if (details?.teleCreditServices && role !== "Superadmin") {
        setcreditData(details.teleCreditServices);
        setIsHospitalData(true);
      }
      if (details?.teleCreditServicesForCase2Case && role !== "Superadmin") {
        setCase2caseData(details.teleCreditServicesForCase2Case);
        setIsHospitalData(true);
      }
    }
  }, [hospitalDetailsData]);

  useEffect(() => {
    if (role === "Superadmin" && isHospitalSuperAdminEditing) {
      dispatch(hospitalDetailApi({ hospitalId: hospitalData?._id }));
      // if (hospitalData && Object.keys(hospitalData).length > 0) {
      //   updateFormInitialValue(hospitalData);
      // }
    }
  }, [role, isHospitalSuperAdminEditing, hospitalData]);

  useEffect(() => {
    if (hospitalDetailsData?.status === 'SUCCESS' && role === _roleType.hospitalSuperadmin) {
      const details: any = hospitalDetailsData?.result;
      if (details?.addOns && details?.addOnsAvailable) {
        const addOnsList = details.addOnsAvailable;
        const addOns = Object.keys(addOnsList).filter((key) => addOnsList[key]); // true addons, purchased addons
        const addOnsData = getAddonsResponse?.result?.data.filter((addon: any) => addOns.includes(addon.code));
        setPurchasedAddonsNames(addOnsData?.map((addon: any) => addon?.name));

        const leftOverAddOns = getAddonsResponse?.result?.data.filter((addon: any) => !addOns.includes(addon.code));
        setFormAddons(leftOverAddOns);

      }
      setHospitalDetails(details);

      updateFormInitialValue(details);

      if (details?.country) {
        fetchStates(details?.country, '', 'state');
      }
      if (details?.country && details?.state) {
        fetchStates(details?.country, details?.state, 'city');
      }
      if (details?.teleCreditServices && role !== "Superadmin") {
        setcreditData(details.teleCreditServices);
        setIsHospitalData(true);
      }
      if (details?.teleCreditServicesForCase2Case && role !== "Superadmin") {
        setCase2caseData(details.teleCreditServicesForCase2Case);
        setIsHospitalData(true);
      }
    }
  }, [hospitalDetailsData]);

  useEffect(()=>{
    if(role === _roleType.hospitalSuperadmin ){
      const hospitalId = hospitalData?.user?.hospitalId || localStorage.getItem('hospitalId') || sessionStorage.getItem('hospitalId');
       dispatch(hospitalDetailApi({ hospitalId: hospitalId}));
    }
  },[isHospitalSuperAdminEditing])

  useEffect(() => {
    // Clear form data when component unmounts
    return () => {
      setFormInitialValue({
        from: '',
        isApproved: false,
        product: [],
        hospitalName: '',
        hospitalEmailId: '',
        address: '',
        zipCode: '',
        country: '',
        state: '',
        city: '',
        hfrId: '',
        website: '',
        contactNumberCountryCode: '+91',
        contactNumber: '',
        whatsappCountryCode: '+91',
        whatsappNumber: '',
        emergencyContactNumberCountryCode: '+91',
        emergencyContactNumber: '',
        numberOfHealthcareProfessionals: '',
        specialitites: [],
        signature: '',
        superAdminName: '',
        superAdminEmail: '',
        superAdminContactNumber: '',
        superAdminContactNumberCountryCode: '+91',
        superAdminWhatsappNumber: '',
        superAdminWhatsappNumberCountryCode: '+91',
        sameAsContact: false,
        superAdminSameAsContact: false,
        telepathology: false,
        teleradiology: false,
        teleCreditServices: [],
        teleCreditServicesForCase2Case: [],
        speechToText: false,
        aiServices:false,
        government:false,
        CASE_TO_CASE_PLAN:false
      });
      setHospitalDetails(defaultHospitalDetails);
      // dispatch(clearHospitalDetails());
    }
  }, []);

  useEffect(() => {
    if (!edit) {
      // Clear form when adding new hospital
      setFormInitialValue({
        ...formInitialValue,
        from: '',
        isApproved: false,
        product: [],
        hospitalName: '',
        // ... rest of the initial empty values
      });
      dispatch(clearHospitalDetails());
      setHospitalDetails(defaultHospitalDetails);
    } else if (edit && (role === _roleType.hospitalSuperadmin || role === _roleType.superAdmin)) {
      const hospitalId = hospitalData?.user?.hospitalId;
      if (hospitalId) {
        dispatch(hospitalDetailApi({ hospitalId }));
      }
    }

    fetchCommonData();
    dispatch(getBillingGeneralSettings());
  }, [edit]);

  useEffect(() => {
    if (billingGeneralSettingsData?.status === 'success' && billingGeneralSettingsData?.result?.currency) {
      const newCountryCode = getCurrencyContact(billingGeneralSettingsData.result.currency);
      setSelectedCountryCode(newCountryCode);
    }
  }, [billingGeneralSettingsData]);

  const fetchCommonData = async () => {
    try {
      const commonData: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.list, body: {}, headerType: 'json' })
      if (commonData?.status) {
        setCountryCode(commonData?.result?.countryCode);
        setCountryList(commonData?.result?.countryList);
        setSpecialitities(
          commonData?.result?.department?.map(item =>
            item === "Multi specality hospital"
              ? { value: "Multispeciality Hospital", label: "Multispeciality Hospital" }
              : { value: item, label: item }
          )
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const base64ToBlob = (base64, type = 'image/png') => {
    const byteCharacters = atob(base64.split(',')[1]); // Decode base64 string
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type });
  };

  useEffect(() => {
    if (imageResponse?.status === "SUCCESS") {
      if (folderName === 'profile') {
        setProfileImage(imageResponse?.result)
      }
      else {
        setSignatureImage(imageResponse?.result)
      }
    }
  }, [imageResponse])

  const saveSignature = (signatureData: string, setFieldValue: (field: string, value: any) => void) => {
    setOpenSignaturePad(false);
    const blob = base64ToBlob(signatureData);
    const file = new File([blob], `signature_${Date.now()}.png`, { type: 'image/png' });
    setFieldValue('signature', signatureData);
    uploadSignatureFile(file, setFieldValue);
  };

  const openSignaturePad = () => {
    setOpenSignaturePad(true)
  }

  const handlePasswordChange = async (key, values) => {
    setPassword({ ...password, [key]: values });
  }

  const handlePasswordSubmit = async () => {
    setConfirmationModal(false)
    const { currentPassword, newPassword, confirmPassword } = password;

    if (!currentPassword) {
      setErrorMessage('Current password is required.');
      return;
    }
    if (!newPassword) {
      setErrorMessage('New password is required.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setErrorMessage('New password and confirm password do not match.');
      return;
    }

    const hospitalId = hospitalData?.user?.hospitalId || localStorage.getItem('hospitalId') || sessionStorage.getItem('hospitalId');
    const userId = hospitalData?.user?._id || localStorage.getItem('userId') || sessionStorage.getItem('userId');

    const payload = {
      hospitalId: hospitalId,
      userId: userId,
      currentPassword: currentPassword,
      newPassword: newPassword,
      confirmPassword: confirmPassword
    }

    const response = await dispatch(changePasswordApi(payload));

    // Handle API response
    if (response?.meta?.requestStatus === 'fulfilled') {
      if (response?.payload?.status === "SUCCESS") {
        setTitle('Password changed successfully.');
        setModal(true); // Show success modal on success
        setPassword({ ...password, currentPassword: '', newPassword: '', confirmPassword: '' });
        setErrorMessage('');
      } else if (response?.payload?.status === "ERROR") {
        setErrorMessage(response?.payload?.msg);
      }
    } else if (response?.error?.message) {
      setErrorMessage(response.error.message); // Set error message from API
    }
  }

  const fetchStates = async (country, state, type) => {
    const response: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.statecity, body: { type: type, countryCode: country, stateCode: state }, headerType: 'json' })
    if (response?.status) {
      if (type === 'state') {
        setStates(response.result);
      }
      else {
        setCities(response.result)
      }
    }
  }

  const handleclosemodal = () => {
    setModal(false)
  }
  const cancel = (resetForm: (nextValues?: any) => void) => {
    if (edit || isHospitalSuperAdminEditing) {
      if (hospitalDetails && Object.keys(hospitalDetails).length > 0) {
        const apiValues = {
          from: hospitalDetails?.from || '',
          isApproved: hospitalDetails?.isApproved || false,
          product: hospitalDetails?.product || [],
          hospitalName: hospitalDetails.hospitalName || '',
          hospitalEmailId: hospitalDetails.hospitalEmailId || '',
          address: hospitalDetails?.address || '',
          zipCode: hospitalDetails?.zipCode || '',
          country: hospitalDetails?.country || '',
          state: hospitalDetails?.state || '',
          city: hospitalDetails?.city || '',
          hfrId: hospitalDetails.hfrId || '',
          website: hospitalDetails.website || '',
          contactNumberCountryCode: hospitalDetails.contactNumberCountryCode || '+91',
          contactNumber: getLocalPhoneNumber(hospitalDetails.contactNumber),
          whatsappCountryCode: hospitalDetails.whatsappCountryCode || '+91',
          whatsappNumber: getLocalPhoneNumber(hospitalDetails.whatsapp),
          emergencyContactNumberCountryCode: hospitalDetails.emergencyContactNumberCountryCode || '+91',
          emergencyContactNumber: getLocalPhoneNumber(hospitalDetails.emergencyContactNumber),
          numberOfHealthcareProfessionals: hospitalDetails.noOfHealthCareProfessional || '',
          specialitites: hospitalDetails.specialitites || [],
          signature: hospitalDetails.user?.signature || '',
          superAdminName: hospitalDetails.user?.name || '',
          superAdminEmail: hospitalDetails.user?.email || '',
          superAdminContactNumber: getLocalPhoneNumber(hospitalDetails.user?.contactNumber),
          superAdminContactNumberCountryCode: hospitalDetails.user?.countryCode || '+91',
          superAdminWhatsappNumber: getLocalPhoneNumber(hospitalDetails.user?.whatsapp),
          superAdminWhatsappNumberCountryCode: hospitalDetails.user?.whatsappCountryCode || '+91',
          sameAsContact: hospitalDetails.sameAsContact || false,
          superAdminSameAsContact: hospitalDetails.user?.superAdminSameAsContact || false,
          telepathology: hospitalDetails.telepathology || false,
          teleradiology: hospitalDetails.teleradiology || false,
          teleCreditServices: hospitalDetails?.teleCreditServices || [],
          teleCreditServicesForCase2Case: hospitalDetails?.teleCreditServicesForCase2Case || [],
          speechToText: hospitalDetails?.speechToText || false,
          aiServices: hospitalDetails.aiServices || false,
          government: hospitalDetails.government || false,
        };
        resetForm({ values: apiValues });
      }
    } else {
      const defaultValues = {
        from: '',
        isApproved: false,
        product: [],
        hospitalName: '',
        hospitalEmailId: '',
        address: '',
        zipCode: '',
        country: '',
        state: '',
        city: '',
        hfrId: '',
        website: '',
        contactNumberCountryCode: '+91',
        contactNumber: '',
        whatsappCountryCode: '+91',
        whatsappNumber: '',
        emergencyContactNumberCountryCode: '+91',
        emergencyContactNumber: '',
        numberOfHealthcareProfessionals: '',
        specialitites: [],
        signature: '',
        superAdminName: '',
        superAdminEmail: '',
        superAdminContactNumber: '',
        superAdminContactNumberCountryCode: '+91',
        superAdminWhatsappNumber: '',
        superAdminWhatsappNumberCountryCode: '+91',
        sameAsContact: false,
        superAdminSameAsContact: false,
        telepathology: false,
        teleradiology: false,
        teleCreditServices: [],
        teleCreditServicesForCase2Case: [],
        speechToText: false,
        aiServices: false,
        government: false,
      };
      resetForm({ values: defaultValues });
    }

    if (role === 'hospitalsuperadmin' && isHospitalSuperAdminEditing) {
      setIsHospitalSuperAdminEditing(false);
    } else {
      navigate(-1);
    }
  };

  const updateFormInitialValue = (data: HospitalDetails) => {
    if (!data) return;

    const formValues = {
      from: data?.from || '',
      isApproved: data?.isApproved || false,
      product: data?.product || [],
      hospitalName: data.hospitalName || '',
      hospitalEmailId: data.hospitalEmailId || '',
      address: data?.address || '',
      zipCode: data?.zipCode || '',
      country: data?.country || '',
      state: data?.state || '',
      city: data?.city || '',
      hfrId: data.hfrId || '',
      website: data.website || '',
      contactNumberCountryCode: data.contactNumberCountryCode || '+91',
      contactNumber: getLocalPhoneNumber(data.contactNumber),
      whatsappCountryCode: data.whatsappCountryCode || '+91',
      whatsappNumber: getLocalPhoneNumber(data.whatsapp),
      emergencyContactNumberCountryCode: data.emergencyContactNumberCountryCode || '+91',
      emergencyContactNumber: getLocalPhoneNumber(data.emergencyContactNumber),
      numberOfHealthcareProfessionals: data.noOfHealthCareProfessional || '',
      specialitites: data.specialitites || [],
      signature: data.user?.signature || '',
      superAdminName: data.user?.name || '',
      superAdminEmail: data.user?.email || '',
      superAdminContactNumber: getLocalPhoneNumber(data.user?.contactNumber),
      superAdminContactNumberCountryCode: data.user?.countryCode || '+91',
      superAdminWhatsappNumber: getLocalPhoneNumber(data.user?.whatsapp),
      superAdminWhatsappNumberCountryCode: data.user?.whatsappCountryCode || '+91',
      sameAsContact: data.sameAsContact || false,
      superAdminSameAsContact: data.user?.superAdminSameAsContact || false,
      telepathology: data.telepathology || false,
      teleradiology: data.teleradiology || false,
      teleCreditServices: data?.teleCreditServices || [],
      teleCreditServicesForCase2Case: data?.teleCreditServicesForCase2Case || [],
      speechToText:data?.speechToText || false,
      aiServices : data.aiServices || false,
      government : data.government || false,
      subscriptionDetail : data.subscriptionDetail || {},
      addOnsPurchased : data.addOnsPurchased || [],
      CASE_TO_CASE_PLAN : data.CASE_TO_CASE_PLAN || false
    };

    setFormInitialValue(formValues);
  };

  const isDarkMode = useTheme();

  const handleSave = async (values, resetForm) => {
    setLoading(true)
    let obj = {}
    if (edit || isHospitalSuperAdminEditing) {
      obj = {
        _id: hospitalData?._id || hospitalDetails?._id,
        hospitalName: values?.hospitalName,
        hospitalEmailId: values?.hospitalEmailId,
        contactNumber: values?.contactNumber,
        address: values?.address,
        zipCode: values?.zipCode,
        country: values?.country,
        state: values?.state,
        city: values?.city,
        hfrId: values?.hfrId,
        whatsapp: values?.whatsappNumber,
        emergencyContactNumber: values?.emergencyContactNumber,
        contactNumberCountryCode: values?.contactNumberCountryCode,
        whatsappCountryCode: values?.whatsappCountryCode,
        emergencyContactNumberCountryCode: values?.emergencyContactNumberCountryCode,
        noOfHealthCareProfessional: values?.numberOfHealthcareProfessionals,
        specialitites: values?.specialitites,
        website: values?.website,
        sameAsContact: values?.sameAsContact,
        telepathology: values?.telepathology,
        teleradiology: values?.teleradiology,
        speechToText: values?.speechToText,
        aiServices: values?.aiServices,
        CASE_TO_CASE_PLAN: values?.CASE_TO_CASE_PLAN,
        government: values?.government,
        adminDetails: {
          _id: hospitalData?.user?._id || hospitalDetails?.user?._id,
          name: values?.superAdminName,
          email: values?.superAdminEmail,
          countryCode: values?.superAdminContactNumberCountryCode,
          contactNumber: values?.superAdminContactNumber,
          whatsappCountryCode: values?.superAdminWhatsappNumberCountryCode,
          whatsapp: values?.superAdminWhatsappNumber,
          superAdminSameAsContact: values?.superAdminSameAsContact,
          signature: imageResponse.result,
        },
        teleCreditServices: updatedTableData.map((item) => ({
          _id: item._id, // Include _id for existing records
          modality: item.modality,
          studyRegion: item.studyRegion,
          credit: item.credit, // Map credit to price for backend
        })),
        teleCreditServicesForCase2Case: updatedCase2CaseTableData.map((item) => ({
          _id: item._id,
          modality: item.modality,
          credit: item.credit,
        })),
      }
    }
    else {
      obj = {
        hospitalDetail: {
          hospitalName: values?.hospitalName,
          hospitalEmailId: values?.hospitalEmailId,
          contactNumber: values?.contactNumber,
          address: values?.address,
          zipCode: values?.zipCode,
          country: values?.country,
          state: values?.state,
          city: values?.city,
          hfrId: values?.hfrId,
          whatsapp: values?.whatsappNumber,
          emergencyContactNumber: values?.emergencyContactNumber,
          contactNumberCountryCode: values?.contactNumberCountryCode,
          whatsappCountryCode: values?.whatsappCountryCode,
          emergencyContactNumberCountryCode: values?.emergencyContactNumberCountryCode,
          noOfHealthCareProfessional: values?.numberOfHealthcareProfessionals,
          specialitites: values?.specialitites,
          website: values?.website,
          sameAsContact: values?.sameAsContact,
          telepathology: values?.telepathology,
          teleradiology: values?.teleradiology,
          speechToText: values?.speechToText,
          aiServices: values?.aiServices,
          CASE_TO_CASE_PLAN: values?.CASE_TO_CASE_PLAN,
          government: values?.government,
          teleCreditServices: updatedTableData.map((item) => ({
            _id: item._id, // Include _id for existing records
            modality: item.modality,
            studyRegion: item.studyRegion,
            credit: item.credit, // Map credit to price for backend
          })),
          teleCreditServicesForCase2Case: updatedCase2CaseTableData.map((item) => ({
            _id: item._id,
            modality: item.modality,
            studyRegion: item.studyRegion,
            credit: item.credit,
          })),
        },
        adminDetails: {
          name: values?.superAdminName,
          email: values?.superAdminEmail,
          countryCode: values?.superAdminContactNumberCountryCode,
          contactNumber: values?.superAdminContactNumber,
          whatsappCountryCode: values?.superAdminWhatsappNumberCountryCode,
          whatsapp: values?.superAdminWhatsappNumber,
          superAdminSameAsContact: values?.superAdminSameAsContact,
          signature: imageResponse.result,
        },

      }
    }
    try {
      const response = await apiRequest({ method: 'POST', endUrl: edit || role === 'hospitalsuperadmin' ? _hospitalUrls.update : _hospitalUrls.add, headerType: 'json', body: obj })
      if (response?.status) {
        if (role !== 'hospitalsuperadmin') {
          setTitle(response?.msg)
        }
        else
          setTitle("Profile updated successfully.")
        setModal(true)
        if (edit || isHospitalSuperAdminEditing) {
          dispatch(hospitalDetailApi({ hospitalId: hospitalData?._id || hospitalDetails?._id }));
          setIsHospitalSuperAdminEditing(false);
        } else {
          setTimeout(() => {
            navigate("/hospital",{ replace: true })
          }, 500);
        }
      }
    }
    catch (err) {
    } finally {
      setLoading(false)
    }
    resetForm();
  }

  const handleBuyExtraStorageSubmit = (storage,type) => {
    const hospital_code = localStorage.getItem('hospitalCode') || sessionStorage.getItem('hospitalCode');
    // @ts-ignore
    const creditValue = hospitalDetailsData?.result?.creditValue?.creditValue
    // @ts-ignore
    const creditPerGb = hospitalDetailsData?.result?.creditPerGbDetail?.value

    if(!creditPerGb || !creditValue){
      const messgae =  `Please contact Superadmin or Try after some time`
         uiNotificationService.show({
           title: 'Something went wrong!',
           message: messgae,
           type: 'error',
           duration: 9000,
           position: 'topRight'
         })
    }
    let payload

    if(type == 'cash'){
      payload = {
        "product_name": 'Extra Storage',
        "product_amount": 0,
        "purchase_type": _purchase_type.EXTRA_STORAGE,
        "hospital_code": hospital_code,
        "extra_storage": storage,
        "extraStoragePlan": extraStoragePlan
      }
      setLoading(true)
      dispatch(createStripePortalSession(payload)).catch((error) => {
        console.error('Error creating Stripe portal session:', error);
        setLoading(false);
      });
    }

    else if( type == 'credit'){
      setLoading(true)
      payload = {
        hospital_code: hospital_code,
        extra_storage: storage,
        "extraStoragePlan": extraStoragePlan
      }
      dispatch(deductCreditForStorage(payload)).finally(() => {
        setLoading(false);
      });
    }
  }

  const hospitalHavePlan = () => {
    // Returns true if hospital has at least one plan in the product array, else false
    const productArr = hospitalDetailsData?.result?.product;
    return Array.isArray(productArr) && productArr.length > 0;
  }

  const handlePauseService = (hospitalId) => {
    try {
      setLoading(true);
      setPauseConfirmationModal({ ...pauseConfirmationModal, isOpen: false });
      const obj = {
        _id: hospitalId,
        isApproved: false
      }
      dispatch(odooApprovedApi(obj)).then((res) => {
        if (res?.payload?.success) {
          setLoading(false);
          setModal(true);
          setTitle("Hospital's free trial has been successfully ended");
          setTimeout(() => {
            navigate(-1);
          }, 1000);
        }
      }).catch((err) => {
        setLoading(false);

        console.error("Error pausing service:", err)
        uiNotificationService.show({
          title: 'Error',
          message: err.msg || 'Failed to pause service',
          type: 'error',
          duration: 9000,
          position: 'topRight'
        });
      });
    } catch (err) {
      console.error("Error pausing service:", err);

    }
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.get('payment_success') === 'true') {
        uiNotificationService.show({
        title: 'Success',
        message: "Payement success!",
        type: 'success',
        duration: 9000,
        position: 'topRight'
      })
    }

    if (params.get('payment_canceled') === 'true') {
       uiNotificationService.show({
        title: 'Failed',
        message: "Payement get cancelled!",
        type: 'error',
        duration: 9000,
        position: 'topRight'
      })
    }
  }, []);
  return (
    <>
      <div className={`hospital page page__full ${isDarkMode?.isDarkMode ? 'dark-mode' : ''}`} style={
        isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
      }>
        {role === "hospitalsuperadmin" ? (
          isHospitalSuperAdminEditing ? (
            <Header isBack={true} title="Edit Clinic/Hospital Profile" handleIsBackFunctionality={() => setIsHospitalSuperAdminEditing(false)} />
          ) : (
            <Header isBack={false} title="Clinic/Hospital Profile" />
          )
        ) : edit ? (
          <Header isBack={true} title="Edit Clinics or Hospitals" />
        ) : (
          <Header isBack={true} title="Add Clinic or Hospital" />
        )}
        <div className='page__body'>
          {role !== 'Superadmin' && (
            <div className="subscriptionWrap">
              <h2 className="title title--h3 title--semibold">Subscription Details</h2>
              <div className="subscriptionWrap__row">
                <div className="subscriptionWrap__row__col">
                  <div className="card">
                    <div className="card__head">Plan Types</div>
                    <div className="card__body">
                      <h2 className="title title--semibold">
                        {`${formInitialValue?.product?.[0]?.name ? formInitialValue?.product?.[0]?.name : "N/A"}`}
                      </h2>
                      <div className="btn__group">
                        <PricingCard
                          key={formInitialValue?.product?.[0]}
                          loading={loading}
                          setLoading={setLoading}
                          planDetails={formInitialValue}
                          showModal={showModal}
                          expiryDate={hospitalDetailsData?.result?.subscriptionDetail?.expiry_date}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="subscriptionWrap__row__col">
                  <div className="card">
                    <div className="card__head">Add ons</div>
                    <div className="card__body">
                      <div className='subtitleWrapper'>
                        {purchasedAddonsNames?.length > 0 ? (
                          purchasedAddonsNames.map((name, index) => (
                            <h2 className='title title--semibold' key={index}>{name}</h2>
                          ))
                        ) : (
                          <h2 className='title title--semibold'>N/A</h2>
                        )}
                      </div>
                      <div className="btn__group">
                        <button
                          className={`btn ${formAddons?.length > 0 ? "btn__white btn--full" : ""}`}
                          onClick={() => {
                            if (formAddons?.length > 0) {
                              setIsAddOnPopupOpen(true);
                            }
                          }}
                        >
                          Buy Add Ons
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="subscriptionWrap__row__col">
                  <div className="card">
                    <div className="card__head">Plan Expiry Date</div>
                    <div className="card__body">
                      <h2 className="title title--semibold">
                        {hospitalDetailsData?.result?.subscriptionDetail?.expiry_date ?
                        formatDate(hospitalDetailsData?.result?.subscriptionDetail?.expiry_date) : 'N/A'}
                      </h2>
                      <div className="btn__group">
                        <button className="btn">
                          {hospitalDetailsData?.result?.subscriptionDetail?.daysLeftForExpiration < 0
                            ? 'Expired'
                            :
                            hospitalDetailsData?.result?.subscriptionDetail?.daysLeftForExpiration ?
                            `${hospitalDetailsData?.result?.subscriptionDetail?.daysLeftForExpiration} Days Left` : 'N/A'
                          }
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="subscriptionWrap__row__col">
                  <div className="card">
                    <div className="card__head">Data Remaining</div>
                    <div className="card__body">
                      <h2 className="title title--semibold">
                        {convertKBtoGB(hospitalDetailsData?.result?.subscriptionDetail?.remainingStorageinKB, 3)}
                        <sub>
                          / {convertKBtoGB(hospitalDetailsData?.result?.subscriptionDetail?.storageAllocatedinKB, 3)} GB
                        </sub>
                      </h2>
                      <p
                        style={{
                          cursor: 'pointer',
                          color: isDarkMode ? '#4ECDC4' : '#51A196',
                          borderBottom: hover ? `1px solid ${isDarkMode ? '#4ECDC4' : '#51A196'}` : 'none',
                          display: 'inline-block',
                        }}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        onClick={() => setIsExtraStoragePlanDetailPopupOpen(true)}
                      >
                        See plan details
                      </p>
                      <div className="btn__group">
                        <button
                          onClick={() => setIsBuyExtraStoragePlanModalOpen(true)}
                          className="btn btn__white btn--full"
                          disabled={hospitalDetailsData?.result?.CASE_TO_CASE_PLAN ? true : false}
                        >
                          {calculateDaysLeft(hospitalDetailsData?.result?.subscriptionDetail?.extraStoragePlan?.extraStorageExpiryDate) <= 0
                            ? 'Expired'
                            : 'Buy Extra Storage'
                          }
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="subscriptionWrap__row__col">
                  <div className="card">
                    <div className="card__head">Credit in Wallet</div>
                    <div className="card__body">
                      <h2 className="title title--semibold">
                        {hospitalDetailsData?.result?.remainingCredits != null &&
                        hospitalDetailsData?.result?.totalCredits != null
                          ? (
                              <>
                                {hospitalDetailsData.result.remainingCredits}
                                <sub>/{hospitalDetailsData.result.totalCredits}</sub>
                              </>
                            )
                          : 'N/A'}
                      </h2>
                      <div className="btn__group">
                        <button
                          onClick={() => setIsModalOpen(true)}
                          className="btn btn__white btn--full"
                        >
                          Top-up Credits
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className='details'>
            <div className='form form-innersec'>
              <Formik
                initialValues={formInitialValue}
                enableReinitialize
                validationSchema={hospitalFormSchema}
                onSubmit={(values, { resetForm }) =>
                  handleSave(values, resetForm)
                }
              >
                {({
                  errors,
                  values,
                  handleChange,
                  handleBlur,
                  touched,
                  setFieldValue,
                  setFieldTouched,
                  resetForm,
                }) => (
                  <Form>
                    <section className='form__section'>
                      {role === "hospitalsuperadmin" ?
                        <div className='flex justify-between items-center'>
                          {!isHospitalSuperAdminEditing ?
                            <h1 className='form__section__title'>Profile Details</h1>
                            : <h1 className='form__section__title'>Edit Profile Details</h1>
                          }
                          {!isHospitalSuperAdminEditing &&
                            <button className="custom-button main-theme flex items-center" onClick={() => setIsHospitalSuperAdminEditing(true)}>
                              <img src={ICONS["edit"]} alt="edit" style={{ filter: "brightness(0) invert(1)" }} className="mr-2" />
                              Edit
                            </button>
                          }
                        </div>
                        :
                        <h1 className='form__section__title'>{edit ? 'Edit' : 'Add'} Clinic or Hospital</h1>
                      }
                      <div className='formRow formRow__3'>
                        <div className="formCol">
                          <div className="form__Field">
                            <label className="form__label" htmlFor='hospitalName'>
                              Name
                              <span className="required-asterisk">*</span>
                            </label>
                            <input
                              className="form__input form__input--sm"
                              type="text"
                              id="hospitalName"
                              name="hospitalName"
                              placeholder="Name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.hospitalName}
                              autoComplete='off'
                              disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                            />
                            <ErrorMessage name="hospitalName" component="div" className="error text-error" />
                          </div>
                        </div>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" >
                              Email ID<span className="required-asterisk">*</span>
                            </label>
                            <input
                              className="form__input form__input--sm"
                              type="text"
                              id="hospitalEmailId"
                              name="hospitalEmailId"
                              placeholder="Email ID"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.hospitalEmailId}
                              autoComplete='off'
                              disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                            />
                            <ErrorMessage name="hospitalEmailId" component="div" className="error text-error" />

                          </div>
                        </div>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='specialitites'>Specialties
                              <span className="required-asterisk">*</span>
                            </label>
                            <Select id='specialitites'
                              placeholder="Select"
                              className={`${role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing ? "input-disabled" : ""} cutom-bg-white `}
                              isMulti={true}
                              isClearable={false}
                              isSearchable={true}
                              closeMenuOnSelect={false}
                              hideSelectedOptions={false}
                              isDisabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                              options={specialitites}
                              value={values.specialitites}
                              components={{ ValueContainer: SpecialtiesValueContainer }}
                              onChange={(selectedOptions) => {
                                const newSpecialties = selectedOptions ? selectedOptions.map(option => option) : [];
                                setFieldValue('specialitites', newSpecialties);
                              }
                              }
                            ></Select>
                            <ErrorMessage name="specialitites" component="div" className="error text-error" />
                          </div>
                        </div>
                      </div>
                      <div className="formRow formRow__2">
                        <div className='formCol'>
                          <div className='formRow formRow__2'>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label" htmlFor='address'>Address</label>
                                <input
                                  className="form__input form__input--sm"
                                  type="text"
                                  id="address"
                                  name="address"
                                  placeholder="Address"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.address}
                                  autoComplete='off'
                                  disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                                />
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className='form__Field'>
                                <label className="form__label" htmlFor='zipCode'>Zip Code</label>
                                <input
                                  className="form__input form__input--sm"
                                  type="text"
                                  id="zipCode"
                                  name="zipCode"
                                  placeholder="Zip Code"
                                  onChange={(e) => {
                                    const value = e.target.value.replace(/[^0-9]/g, '');
                                    e.target.value = value;
                                    handleChange(e);
                                  }}
                                  onBlur={handleBlur}
                                  maxLength={6}
                                  value={values.zipCode}
                                  pattern="[0-9]*"
                                  inputMode="numeric"
                                  disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                                />
                              </div>
                              <ErrorMessage name="zipCode" component="div" className="error text-error" />
                            </div>
                          </div>
                        </div>
                        <div className='formCol'>
                          <div className='formRow formRow__3'>
                            <div className='formCol'>
                              <div className='form__Field'>
                                <label className="form__label" htmlFor='country' >Country</label>
                                <select
                                  id="country"
                                  name="country"
                                  className={`${role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing ? "input-disabled" : ""} form__select form__select--sm`}
                                  onChange={(e) => {
                                    handleChange(e);
                                    fetchStates(e.target.value, '', 'state')
                                  }}
                                  onBlur={handleBlur}
                                  value={values.country}
                                  autoComplete='off'
                                  disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                                  style={customStyle.select}
                                >
                                  <option value="">Select</option>
                                  {countryList.map((option) => (
                                    <option key={option.value} value={option.value}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className='form__Field'>
                                <label className="form__label" htmlFor='state'>State</label>
                                <select
                                  id="state"
                                  name="state"
                                  className={`${role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing ? "input-disabled" : ""} form__select form__select--sm`}
                                  onChange={(e) => {
                                    handleChange(e);
                                    fetchStates(values.country, e.target.value, 'city')
                                  }}
                                  onBlur={handleBlur}
                                  value={values.state}
                                  autoComplete='off'
                                  disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                                  style={customStyle.select}
                                >
                                  <option value="">Select</option>
                                  {states.map((option) => (
                                    <option key={option.isoCode} value={option.isoCode}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className='form-Field'>
                                <label className="form__label" htmlFor='city'>City</label>
                                <select
                                  id="city"
                                  name="city"
                                  className={`${role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing ? "input-disabled" : ""} form__select form__select--sm`}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.city}
                                  autoComplete='off'
                                  disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                                  style={customStyle.select}
                                >
                                  <option value="">Select</option>
                                  {cities.map((option) => (
                                    <option key={option.name} value={option.name}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='formRow formRow__4'>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='billingPhoneNumberCountryCode'>
                              Contact Number<span className="required-asterisk">*</span>
                            </label>
                            <div className='form__groupField form__groupField--phonenumber'>
                              <select className="form__select form__select--sm"
                                style={customStyle.select}
                                id="contactNumberCountryCode"
                                name="contactNumberCountryCode"
                                disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                                value={values.contactNumberCountryCode}
                                onChange={(e) => {
                                  handleChange(e);
                                  if (values.sameAsContact) {
                                    setFieldValue('whatsappCountryCode', e.target.value);
                                    setFieldValue('whatsappNumber', values?.contactNumber);
                                  }
                                }}>
                                {countryCode.map((option) => (
                                  <option
                                    key={option}
                                    value={option}
                                  >
                                    {option}
                                  </option>
                                ))}
                              </select>
                              <input type="text"
                                className="form__input form__input--sm"
                                id="contactNumber"
                                name="contactNumber"
                                placeholder="Contact Number"
                                maxLength={10}
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                  handleChange(e);
                                }}
                                pattern="[0-9]*"
                                onChange={(e) => {
                                  handleChange(e);
                                  if (values.sameAsContact) {
                                    setFieldValue('whatsappNumber', e.target.value);
                                    setFieldValue('whatsappCountryCode', values?.contactNumberCountryCode);
                                  }
                                }}
                                onBlur={handleBlur}
                                value={values.contactNumber}
                                disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                              />
                            </div>
                            <ErrorMessage name="contactNumber" component="div" className="error text-error" />
                          </div>
                        </div>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='whatsappNumber'>Whatsapp Number</label>
                            <div className="form__groupField form__groupField--phonenumber">
                              <select
                                className="form__select form__select--sm"
                                style={customStyle.select}
                                name="whatsappCountryCode"
                                disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                                value={values.whatsappCountryCode}
                                onChange={handleChange}
                              >
                                {countryCode.map((option) => (
                                  <option
                                    key={option}
                                    value={option}
                                  >
                                    {option}
                                  </option>
                                ))}
                              </select>
                              <input
                                type="text"
                                className="form__input form__input--sm"
                                id="whatsappNumber"
                                name="whatsappNumber"
                                maxLength={10}
                                placeholder="Whatsapp Number"
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                  handleChange(e);
                                }}
                                pattern="[0-9]*"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.whatsappNumber}
                                disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                              />
                            </div>
                            <div className="form__checkboxSubField">
                              <div className="form__checkbox">
                                <div className="form__checkbox__option m_0">
                                  <input
                                    className="form__checkbox__input"
                                    id='sameAsContact'
                                    disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                                    checked={values.contactNumber && values.whatsappNumber && values.contactNumber === values.whatsappNumber}
                                    type="checkbox"
                                    name="sameAsContact"
                                    value="sameAsContact"
                                    onChange={(e) => {
                                      setFieldValue('sameAsContact', e.target.checked);
                                      if (e.target.checked) {
                                        setFieldValue('whatsappNumber', values.contactNumber);
                                        setFieldValue('whatsappCountryCode', values?.contactNumberCountryCode);
                                      } else {
                                        setFieldValue('whatsappNumber', '');
                                        setFieldValue('whatsappCountryCode', '');
                                      }
                                    }}
                                  />
                                  <label htmlFor="sameAsContact" className="form__checkbox__label"> Same as Contact Number</label>
                                </div>
                              </div>
                            </div>
                            <ErrorMessage name="whatsappNumber" component="div" className="error text-error" />
                          </div>
                        </div>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='billingPhoneNumberCountryCode'>
                              Emergency Contact Number
                            </label>
                            <div className='form__groupField form__groupField--phonenumber'>
                              <select className="form__select form__select--sm"
                                style={customStyle.select}
                                id="emergencyContactNumberCountryCode"
                                value={values.emergencyContactNumberCountryCode}
                                disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                                onChange={handleChange}
                              >
                                {countryCode.map((option) => (
                                  <option
                                    key={option}
                                    value={option}
                                  >
                                    {option}
                                  </option>
                                ))}
                              </select>
                              <input type="text"
                                className="form__input form__input--sm"
                                id="emergencyContactNumber"
                                name="emergencyContactNumber"
                                placeholder="Emergency Contact Number"
                                maxLength={10}
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                  handleChange(e);
                                }}
                                pattern="[0-9]*"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.emergencyContactNumber}
                                autoComplete='off'
                                disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}>
                              </input>
                            </div>
                          </div>
                        </div>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='numberOfHealthcareProfessionals'>No of Healthcare Professionals</label>
                            <input
                              type="number"
                              className="form__input form__input--sm"
                              id="numberOfHealthcareProfessionals"
                              name="numberOfHealthcareProfessionals"
                              min="0"
                              step="1"
                              placeholder="--"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.numberOfHealthcareProfessionals}
                              autoComplete='off'
                              disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                            />
                          </div>
                        </div>
                      </div>
                      <div className='formRow formRow__4'>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='website'>Website</label>
                            <input
                              className="form__input form__input--sm"
                              type="text"
                              id="website"
                              placeholder="Website"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.website}
                              autoComplete='off'
                              disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                            />
                          </div>
                        </div>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='hrfid'>HFR ID</label>
                            <input
                              className="form__input form__input--sm"
                              type="text"
                              id="hfrId"
                              name="hfrId"
                              placeholder="HFR ID"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.hfrId}
                              autoComplete='off'
                              disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                            />
                          </div>
                        </div>
                      </div>
                    </section>
                    {localStorage.getItem('role') === "hospitalsuperadmin" || sessionStorage.getItem('role') === "hospitalsuperadmin" && isHospitalSuperAdminEditing &&
                      <section className='form__section'>
                        <h1 className='form__section__title'>Change Password</h1>
                        <div className='formRow formRow__4'>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='currentPassword'>
                                Current Password
                              </label>
                              <input
                                type="text"
                                className='form__input form__input--sm'
                                id="currentPassword"
                                name="currentPassword"
                                placeholder="Current Password"
                                value={password.currentPassword}
                                onChange={
                                  (event) => handlePasswordChange('currentPassword', event.target.value)
                                }
                                autoComplete='off'
                              />
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='newPassword'>
                                New Password
                              </label>
                              <input
                                type="text"
                                className='form__input form__input--sm'
                                id="newPassword"
                                name="newPassword"
                                placeholder="New Password"
                                value={password.newPassword}
                                onChange={
                                  (event) => handlePasswordChange('newPassword', event.target.value)
                                }
                                autoComplete='off'
                              />
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='confirmPassword'>
                                Confirm Password
                              </label>
                              <input
                                type="text"
                                className='form__input form__input--sm'
                                id="confirmPassword"
                                name="confirmPassword"
                                placeholder="Confirm Password"
                                value={password.confirmPassword}
                                onChange={
                                  (event) => handlePasswordChange('confirmPassword', event.target.value)
                                }
                                autoComplete='off'
                              />
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor="">&nbsp;</label>
                              <span
                                className='btn btn__primary'
                                onClick={() => {
                                  setTitle("Update Password")
                                  setConfirmationText("Are you sure you want update your password?")
                                  setConfirmationModal(true)
                                }}
                              >
                                Update Password
                              </span>
                            </div>
                          </div>
                          {errorMessage && <span className='text-error text-xs' style={{ color: 'red' }}>{errorMessage}</span>}
                        </div>
                      </section>
                    }

                    <section className='form__section'>
                      <h1 className='form__section__title'>Super Admin Details{isHospitalSuperAdminEditing}</h1>
                      <div className='formRow formRow__4'>
                        <div className="formCol">
                          <div className="form__Field">
                            <label className="form__label" htmlFor='superAdminName'>Name<span className="required-asterisk">*</span>
                            </label>
                            <input
                              type="text"
                              className='form__input form__input--sm'
                              id="superAdminName"
                              name="superAdminName"
                              placeholder="Name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.superAdminName}
                              autoComplete='off'
                            />
                            <ErrorMessage name="superAdminName" component="div" className="error text-error" />
                          </div>
                        </div>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='superAdminEmail'>
                              Email ID
                              <span className="required-asterisk">*</span>
                            </label>
                            <input
                              type="text"
                              className='form__input form__input--sm'
                              id="superAdminEmail"
                              name="superAdminEmail"
                              placeholder="Email ID"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.superAdminEmail}
                              autoComplete='off'
                              disabled={isHospitalSuperAdminEditing}
                            />
                            <ErrorMessage name="superAdminEmail" component="div" className="error text-error" />
                          </div>
                        </div>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='superAdminContactNumberCountryCode'>
                              Contact Number<span className="required-asterisk">*</span>
                            </label>
                            <div className='form__groupField form__groupField--phonenumber'>
                              <select className="form__select form__select--sm"
                                style={customStyle.select}
                                id="superAdminContactNumberCountryCode"
                                disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                                value={values.superAdminContactNumberCountryCode} onChange={(e) => {
                                  handleChange(e);
                                  if (values.superAdminSameAsContact) {
                                    setFieldValue('superAdminWhatsappNumber', values?.superAdminContactNumber);
                                    setFieldValue('superAdminWhatsappNumberCountryCode', e.target.value);
                                  }
                                }}>
                                {countryCode.map((option) => (
                                  <option
                                    key={option}
                                    value={option}
                                  >
                                    {option}
                                  </option>
                                ))}
                              </select>
                              <input type="text"
                                className="form__input form__input--sm"
                                id="superAdminContactNumber"
                                name="superAdminContactNumber"
                                placeholder="Contact Number"
                                disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                                maxLength={10}
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                  handleChange(e);
                                }}
                                pattern="[0-9]*"
                                onChange={(e) => {
                                  handleChange(e);
                                  if (values.superAdminSameAsContact) {
                                    setFieldValue('superAdminWhatsappNumber', e.target.value);
                                    setFieldValue('superAdminWhatsappNumberCountryCode', values?.superAdminContactNumberCountryCode);
                                  }
                                }}
                                onBlur={handleBlur}
                                value={values.superAdminContactNumber}
                                autoComplete='off'>
                              </input>
                            </div>
                            <ErrorMessage name="superAdminContactNumber" component="div" className="error text-error" />

                          </div>
                        </div>
                        <div className='formCol'>
                          <div className="form__Field">
                            <label className="form__label" htmlFor='whatsappNumber'>Whatsapp Number<span className="required-asterisk">*</span></label>
                            <div className="form__groupField form__groupField--phonenumber">
                              <select
                                className="form__select form__select--sm"
                                style={customStyle.select}
                                id="superAdminWhatsappNumberCountryCode"
                                disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                                value={values.superAdminWhatsappNumberCountryCode} onChange={handleChange}>
                                {countryCode.map((option) => (
                                  <option
                                    key={option}
                                    value={option}
                                  >
                                    {option}
                                  </option>
                                ))}
                              </select>
                              <input
                                type="text"
                                className="form__input form__input--sm"
                                id="superAdminWhatsappNumber"
                                name="superAdminWhatsappNumber"
                                placeholder="Whatsapp Number"
                                disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                                maxLength={10}
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                  handleChange(e);
                                }}
                                pattern="[0-9]*"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.superAdminWhatsappNumber}
                                autoComplete='off'
                              >
                              </input>
                            </div>
                            <div className="form__checkboxSubField">
                              <div className="form__checkbox">
                                <div className="form__checkbox__option m_0">
                                  <input
                                    className="form__checkbox__input"
                                    id='superAdminSameAsContact'
                                    disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                                    // Check if the contact and WhatsApp numbers are the same and not empty
                                    checked={values.superAdminContactNumber && values.superAdminWhatsappNumber && values.superAdminContactNumber === values.superAdminWhatsappNumber}
                                    type="checkbox"
                                    name="superAdminSameAsContact"
                                    value="superAdminSameAsContact"
                                    onChange={(e) => {
                                      setFieldValue('superAdminSameAsContact', e.target.checked);
                                      if (e.target.checked) {
                                        // Sync WhatsApp number with contact number if checkbox is checked
                                        setFieldValue('superAdminWhatsappNumber', values.superAdminContactNumber);
                                        setFieldValue('superAdminWhatsappNumberCountryCode', values?.superAdminContactNumberCountryCode);
                                      } else {
                                        // Clear WhatsApp number and country code if checkbox is unchecked
                                        setFieldValue('superAdminWhatsappNumber', '');
                                        setFieldValue('superAdminWhatsappNumberCountryCode', '');
                                      }
                                    }}
                                  />
                                  <label htmlFor="superAdminSameAsContact" className="form__checkbox__label"> Same as Contact Number</label>
                                </div>
                              </div>
                            </div>
                            <ErrorMessage name="superAdminWhatsappNumber" component="div" className="error text-error" />
                          </div>
                        </div>
                      </div>
                      {role !== "Superadmin" ? (
                        <div className="formRow">
                          <div className="formCol">
                            <div className="form__Field">
                              {isHospitalSuperAdminEditing && (
                                <label className="form__label" htmlFor='signature'>
                                  Add/Upload Signature
                                  {role !== "Front Desk" && <span className="required-asterisk">*</span>}
                                </label>
                              )}
                              <div
                                className={`relative ${!isHospitalSuperAdminEditing ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
                              >
                                {isHospitalSuperAdminEditing ? (
                                  <SignatureDropzone
                                    onDrop={(acceptedFiles) => onDrop(acceptedFiles, setFieldValue)}
                                    preview={values?.signature}
                                    accept={{ 'image/jpeg': ['.jpeg', '.jpg'], 'image/png': ['.png'] }}
                                  />
                                ) : (
                                  <div className="pointer-events-none">
                                    <SignatureDropzone
                                      onDrop={() => {}}
                                      preview={values?.signature}
                                      accept={{}}
                                      key="disabled-signature-dropzone"
                                    />
                                  </div>
                                )}
                              </div>
                              {isHospitalSuperAdminEditing && (
                                <>
                                  <div>
                                    <p className="addSignatureNote" style={{ color: isDarkMode?.isDarkMode ? '#ffffff' : '#a00000' }}> Note: Please use a black pen and white paper to sign </p>
                                    <p className='addSignatureDiv -mt-2'>Or</p>
                                  </div>
                                  <div className='addSignatureDiv'>
                                    <button
                                      className="btn btn__white"
                                      type="button"
                                      onClick={openSignaturePad}
                                      style={!isHospitalSuperAdminEditing ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                    >
                                      Add Signature
                                    </button>
                                  </div>
                                </>
                              )}
                              <ErrorMessage name="signature" component="div" className="error text-error" />
                            </div>
                          </div>
                        </div>
                      ) :
                        <></>
                      }
                    </section>
                    <section className='form__section'>
                      <h1 className='form__section__title'>Service Needed</h1>
                      <div className='formRow'>
                        <div className='formCol'>
                          <div className="form__Field">
                            <div className="form__checkbox my-4" style={{display:"flex",justifyContent:"space-between",width:"90%"}}>
                              {serviceConfig
                                .filter((service) => {
                                  if (service.name === 'CASE_TO_CASE_PLAN') {
                                    return role !== 'hospitalsuperadmin';
                                  }
                                  return true;
                                })
                                .map((service) => (
                                  <ServiceCheckbox
                                    key={service.name}
                                    name={service.name}
                                    label={service.label}
                                    checked={values[service.name]}
                                    onChange={(e) => setFieldValue(service.name, e.target.checked)}
                                    disabled={role === "hospitalsuperadmin" && !isHospitalSuperAdminEditing}
                                  />
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='btn__group' style={{ marginBottom: '2rem' }}>

                        {role === "hospitalsuperadmin" ?
                          (isHospitalSuperAdminEditing &&
                            <>

                              <button
                                className='btn btn__primary'
                                type="submit"
                              >
                                Update
                              </button>
                              <button
                                className='btn btn__white'
                                onClick={() => {
                                  cancel(resetForm);
                                  setIsHospitalSuperAdminEditing(false);
                                }}
                              >
                                Cancel
                              </button>
                            </>
                          )
                          :
                          <button
                            className='btn btn__primary'
                            type="submit"
                          >
                            {edit ? 'Update' : 'Save'}
                          </button>
                        }
                        {role === _roleType.superAdmin && edit && hospitalHavePlan() &&
                          <button
                            type='button'
                            className={`btn btn__primary ${hospitalData?.isApproved ? 'bg-green-600' : 'bg-teal-600'}`}
                            onClick={handleApproveHospital}
                            disabled={hospitalData?.isApproved}
                          >
                            {hospitalData?.isApproved ? 'Approved' : 'Approve'}
                          </button>
                        }
                        {/* {role === _roleType.superAdmin && edit && hospitalData?.isApproved && !hospitalHavePlan() &&
                          <button type='button' className='btn btn__primary' onClick={() => {
                            setPauseConfirmationModal({
                              isOpen: true, message: "Are you sure you want to pause free service to this hospital?", onSubmit: () => { handlePauseService(hospitalData?._id) }
                            })
                          }}>
                            Pause
                          </button>
                        } */}
                        {role !== "hospitalsuperadmin" &&
                          <button
                            className='mr-2 custom-button'
                            type="button"
                            onClick={() => cancel(resetForm)}
                          >
                            Cancel
                          </button>
                        }
                      </div>
                      {values.CASE_TO_CASE_PLAN && (
                        <section className='form__section'>
                          <h1 className='form__section__title'>Case-to-Case Credits</h1>
                            <div className='page page__fullBody' style={ isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground }>
                            <div className='page__body'>
                              <CaseToCaseCreditForHospital
                                creditData={case2caseData}
                                setcreditData={setCase2caseData}
                                isHospitalData={isHospitalData}
                                isCaseToCaseEnabled={values.CASE_TO_CASE_PLAN}
                                onTableDataUpdate={setUpdatedCase2CaseTableData}
                                hospitalId={hospitalData?._id}
                                edit={edit}
                                hospitalData={hospitalDetails}
                              />
                            </div>
                          </div>
                        </section>
                      )}
                      {(values.teleradiology || values.telepathology) && (
                        <section className='form__section'>
                          <h1 className='form__section__title'>Teleradiology/Telepathology Prices</h1>
                          <TeleRadiologyPrices
                            creditData={creditData}
                            setcreditData={setcreditData}
                            isHospitalData={isHospitalData}
                            isTelepathologyEnabled={values.telepathology}
                            isTeleradiologyEnabled={values.teleradiology}
                            onTableDataUpdate={setUpdatedTableData}
                            hospitalId={hospitalData?._id}
                            edit={edit}
                          />
                        </section>
                      )}
                    </section>
                    <SignaturePad
                      title={title}
                      message={confirmationText}
                      onConfirm={(signatureData) => saveSignature(signatureData, setFieldValue)}
                      onCancel={() => {
                        setOpenSignaturePad(false);
                      }}
                      isOpen={isOpenSignaturePad}
                    />
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationPopup
        title={title}
        message={confirmationText}
        onConfirm={handlePasswordSubmit}
        onCancel={() => {
          setTitle('')
          setConfirmationText('')
          setConfirmationModal(false)
        }}
        isOpen={confirmationModal}
      />
      <SuccessModal
        isSuccessModalOpen={modal}
        title={title}
        handleCloseModal={handleclosemodal}
      />
      <Loader
        isLoaderOpen={hospitalDetailsData?.loading || loading}
        title="Loading..."
      />
      <ConfirmationPopup
        isOpen={isApprovePopupOpen}
        message={`Are you sure you want to approve ${capitalizeWords(hospitalToApprove?.name)}?`}
        onConfirm={handleApproveConfirm}
        onCancel={handleApproveCancel}
      />
      <ConfirmationPopup
        isOpen={pauseConfirmationModal.isOpen}
        message={pauseConfirmationModal.message}
        onConfirm={pauseConfirmationModal.onSubmit}
        onCancel={() => setPauseConfirmationModal({ ...pauseConfirmationModal, isOpen: false })}
      />
      <AddOnSelectionPopup
        formAddons={formAddons}
        getAddonsResponse={getAddonsResponse}
        isOpen={isAddOnPopupOpen}
        onClose={() => setIsAddOnPopupOpen(false)}
        isMonthly={true} // or pass your billing period state if available
      />
       <CreditTopUpModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleCreditSubmit}
      />
      <BuyExtraStorageModal
        isOpen={isBuyExtraStorageModalOpen}
        onClose={() => setIsBuyExtraStorageModalOpen(false)}
        onSubmit={handleBuyExtraStorageSubmit}
      />
      <ExtraStoragePopup
        isOpen={isBuyExtraStoragePlanModalOpen}
        onClose={() => setIsBuyExtraStoragePlanModalOpen(false)}
        onPlanSelect={(plan) => onExtraStoragePlanSelect(plan)}
        // @ts-ignore
        creditValue={hospitalDetailsData?.result?.creditValue?.creditValue}
        // @ts-ignore
        currentPlan={hospitalDetailsData?.result?.subscriptionDetail?.extraStoragePlan?.planName || 'N/A'}
      />
     <ExtraStoragePlanDetailPopup
        isOpen={isExtraStoragePlanDetailPopupOpen}
        onClose={() => setIsExtraStoragePlanDetailPopupOpen(false)}
        data={hospitalDetailsData?.result}
      />
    </>
  )
}

export default AddEditHospital
